import { useStaticQuery, graphql } from 'gatsby'

export const useHeaderQuery = () => {
  const {
    wp,
    mainMenuDropdownImages,
    mainMenu,
    topBarMenu,
    forRatingValuePart1,
    forRatingValuePart2,
  } = useStaticQuery(graphql`
    query HeaderQuery {
      wp {
        acfOptionsCommonItems {
          commonItems {
            logo {
              localFile {
                publicURL
              }
            }
            navLogo {
              localFile {
                publicURL
              }
            }
            menuLabel
            menuButton1
            menuButton2 {
              url
              title
            }
            mobileCallText
            mobileRequestButton
            phoneNumber
            phoneNumberNj
            callText
            callIcon {
              localFile {
                publicURL
              }
            }
            button2Text
            reviewLabel
            reviewsLink {
              url
            }
            financingLink {
              url
              title
            }
          }
        }
      }
      mainMenuDropdownImages: wpMenu(locations: { eq: PRIMARY_MENU }) {
        mainMenuImages {
          imageContainer {
            image {
              localFile {
                childImageSharp {
                  gatsbyImageData(placeholder: NONE, formats: [WEBP])
                }
              }
            }
            altText
            whichMenuItemIsThisAssociatedWith
          }
        }
      }
      mainMenu: allWpMenuItem(
        filter: { parentDatabaseId: { eq: 0 }, locations: { eq: PRIMARY_MENU } }
      ) {
        nodes {
          label
          path
          childItems {
            nodes {
              label
              path
              childItems {
                nodes {
                  label
                  path
                }
              }
            }
          }
        }
      }
      topBarMenu: allWpMenuItem(
        filter: { parentDatabaseId: { eq: 0 }, locations: { eq: TOP_BAR_MENU } }
      ) {
        nodes {
          label
          path
        }
      }
      forRatingValuePart1: allBirdeyedata(
        filter: { id: { ne: "dummy" }, sourceType: { ne: "Direct Feedback" } }
      ) {
        nodes {
          rating
        }
      }
      forRatingValuePart2: allBirdeyedata(filter: { id: { ne: "dummy" }, rating: { ne: 0 } }) {
        nodes {
          rating
        }
      }
    }
  `)
  return {
    wp,
    mainMenuDropdownImages,
    mainMenu,
    topBarMenu,
    forRatingValuePart1,
    forRatingValuePart2,
  }
}
